import { render } from "./Recorder.vue?vue&type=template&id=cb603898&scoped=true&ts=true"
import script from "./Recorder.vue?vue&type=script&lang=ts"
export * from "./Recorder.vue?vue&type=script&lang=ts"

import "./Recorder.vue?vue&type=style&index=0&id=cb603898&scoped=true&lang=css"

import exportComponent from "/Users/pkraeutli/development/reca/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb603898"]])

export default __exports__